import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1x79l67jvwntn as serializer,
  InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor,
  SEALED_getInstance2brzxtciy6zxg as SEALED_getInstance,
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  STRING_getInstance2md3nu8ka1da4 as STRING_getInstance,
  ENUM_getInstance3qjro8veu1n4s as ENUM_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  serializer2lw83vwvpnyms as serializer_0,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
  ElementMarker33ojvsajwmzts as ElementMarker,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  CLASS_getInstanceycyg9nehd7tt as CLASS_getInstance,
  LIST_getInstance31r89469rgwkw as LIST_getInstance,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames,
  ENUMlmq49cvwy4ow as ENUM,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  CONTEXTUAL_getInstance3iftz58z4hzud as CONTEXTUAL_getInstance,
  MAP_getInstance242ky2ofgg8p5 as MAP_getInstance,
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  MissingFieldException24tqif29emcmi as MissingFieldException,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  OBJECT_getInstanceoefnxtom5aro as OBJECT_getInstance,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  serializer3ikrxnm8b29d6 as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1q7c5q67ysppr as serializer_3,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_0,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  hashCodeq5arwsb9dgti as hashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  KtList3hktaavzmj137 as KtList,
  StringBuildermazzzhj6kkai as StringBuilder,
  KtMap140uvy3s5zad8 as KtMap,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  NumberFormatException3bgsm2s9o4t55 as NumberFormatException,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ClosedRangehokgr73im9z3 as ClosedRange,
  isInterface3d6p8outrmvmk as isInterface,
  contains2c50nlxg7en7o as contains,
  toDouble1kn912gjoizjp as toDouble,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toULongOrNullojoyxi0i9tgj as toULongOrNull,
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance2r8lbbjwejmb0 as Companion_getInstance,
  _ULong___get_data__impl__fggpzb77rs34yu2akv as _ULong___get_data__impl__fggpzb,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  lazy2hsh8ze7j6ikd as lazy_0,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  toLongw1zpgk99d84b as toLong,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl21zkdo3skdvztx as UInt__toString_impl_dbgl21,
  _ULong___init__impl__c78o9k1neui78jb9mlg as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k260qy52yi92xo as ULong__toString_impl_f9au7k,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg3ruswpcjtpyk as UByte__toString_impl_v72jg,
  _UShort___init__impl__jigrne18f2wrm3i4dpy as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee32kikxrf4p0yn as UShort__toString_impl_edaoee,
  captureStack1fzi4aczwc4hg as captureStack,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  ArrayList3it5z8td81qkl as ArrayList,
  singleOrNullrknfaxokm1sl as singleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
  Unitkvevlwgzwiuc as Unit,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  getKClass1s3j9wy1cofik as getKClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains_0,
  plus17rl43at52ays as plus,
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
  toUInt21lx0mz8wkp7c as toUInt,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  toUShort7yqspfnhrot4 as toUShort,
  _UShort___get_data__impl__g02453buibbzrpmeid as _UShort___get_data__impl__g0245,
  toString14fd7g605f91p as toString_1,
  Companion_getInstance316n37o3eume as Companion_getInstance_0,
  Companion_getInstance16xypb6k4bny3 as Companion_getInstance_1,
  Companion_getInstance3956vha054dts as Companion_getInstance_2,
  setOf45ia9pnfhe90 as setOf,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  equals2v6cggk171b6e as equals_0,
  startsWith26w8qjqapeeq6 as startsWith,
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
  single29ec4rh52687r as single,
  Char19o2r8palgjof as Char,
  emptySetcxexqki71qfa as emptySet,
  plus1ogy4liedzq5j as plus_0,
  toInt2q8uldh7sc951 as toInt,
  toList3jhuyej2anx2q as toList,
  enumEntries20mr21zbe3az4 as enumEntries,
  last1vo29oleiqj36 as last,
  removeLast3759euu1xvfa3 as removeLast,
  lastIndexOf2d52xhix5ymjr as lastIndexOf,
  Long2qws0ah9gnpki as Long,
  Char__minus_impl_a2frrh15zl6plytfjgc as Char__minus_impl_a2frrh,
  numberToLong1a4cndvg6c52s as numberToLong,
  charArray2ujmm1qusno00 as charArray,
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
  HashMap1a0ld5kgwhmhv as HashMap,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Json {
  constructor(configuration, serializersModule) {
    Default_getInstance();
    this.c1h_1 = configuration;
    this.d1h_1 = serializersModule;
    this.e1h_1 = new DescriptorSchemaCache();
  }
  mz() {
    return this.d1h_1;
  }
  f1h(serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.i1h();
    }
  }
  g1h(deserializer, string) {
    var lexer = StringJsonLexer_0(this, string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.yu(), null);
    var result = input.wy(deserializer);
    lexer.v1h();
    return result;
  }
}
class Default extends Json {
  constructor() {
    Default_instance = null;
    super(new JsonConfiguration(), EmptySerializersModule());
    Default_instance = this;
  }
}
class JsonBuilder {
  constructor(json) {
    this.w1h_1 = json.c1h_1.p1i_1;
    this.x1h_1 = json.c1h_1.u1i_1;
    this.y1h_1 = json.c1h_1.q1i_1;
    this.z1h_1 = json.c1h_1.r1i_1;
    this.a1i_1 = json.c1h_1.t1i_1;
    this.b1i_1 = json.c1h_1.v1i_1;
    this.c1i_1 = json.c1h_1.w1i_1;
    this.d1i_1 = json.c1h_1.y1i_1;
    this.e1i_1 = json.c1h_1.f1j_1;
    this.f1i_1 = json.c1h_1.a1j_1;
    this.g1i_1 = json.c1h_1.b1j_1;
    this.h1i_1 = json.c1h_1.c1j_1;
    this.i1i_1 = json.c1h_1.d1j_1;
    this.j1i_1 = json.c1h_1.e1j_1;
    this.k1i_1 = json.c1h_1.z1i_1;
    this.l1i_1 = json.c1h_1.s1i_1;
    this.m1i_1 = json.c1h_1.x1i_1;
    this.n1i_1 = json.mz();
  }
  o1i() {
    if (this.m1i_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.d1i_1 === 'type')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException.l(toString(message));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.e1i_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException.l(toString(message_0));
      }
    }
    if (!this.a1i_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.b1i_1 === '    ')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException.l(toString(message_1));
      }
    } else if (!(this.b1i_1 === '    ')) {
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var indexedObject = this.b1i_1;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(indexedObject)) {
          var element = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$4 = false;
            break $l$block;
          }
        }
        tmp$ret$4 = true;
      }
      var allWhitespaces = tmp$ret$4;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!allWhitespaces) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.b1i_1;
        throw IllegalArgumentException.l(toString(message_2));
      }
    }
    return new JsonConfiguration(this.w1h_1, this.y1h_1, this.z1h_1, this.l1i_1, this.a1i_1, this.x1h_1, this.b1i_1, this.c1i_1, this.m1i_1, this.d1i_1, this.k1i_1, this.f1i_1, this.g1i_1, this.h1i_1, this.i1i_1, this.j1i_1, this.e1i_1);
  }
}
class JsonImpl extends Json {
  constructor(configuration, module_0) {
    super(configuration, module_0);
    validateConfiguration(this);
  }
}
class JsonClassDiscriminator {}
class JsonNames {}
class JsonConfiguration {
  constructor(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    allowComments = allowComments === VOID ? false : allowComments;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.p1i_1 = encodeDefaults;
    this.q1i_1 = ignoreUnknownKeys;
    this.r1i_1 = isLenient;
    this.s1i_1 = allowStructuredMapKeys;
    this.t1i_1 = prettyPrint;
    this.u1i_1 = explicitNulls;
    this.v1i_1 = prettyPrintIndent;
    this.w1i_1 = coerceInputValues;
    this.x1i_1 = useArrayPolymorphism;
    this.y1i_1 = classDiscriminator;
    this.z1i_1 = allowSpecialFloatingPointValues;
    this.a1j_1 = useAlternativeNames;
    this.b1j_1 = namingStrategy;
    this.c1j_1 = decodeEnumsCaseInsensitive;
    this.d1j_1 = allowTrailingComma;
    this.e1j_1 = allowComments;
    this.f1j_1 = classDiscriminatorMode;
  }
  toString() {
    return 'JsonConfiguration(encodeDefaults=' + this.p1i_1 + ', ignoreUnknownKeys=' + this.q1i_1 + ', isLenient=' + this.r1i_1 + ', ' + ('allowStructuredMapKeys=' + this.s1i_1 + ', prettyPrint=' + this.t1i_1 + ', explicitNulls=' + this.u1i_1 + ', ') + ("prettyPrintIndent='" + this.v1i_1 + "', coerceInputValues=" + this.w1i_1 + ', useArrayPolymorphism=' + this.x1i_1 + ', ') + ("classDiscriminator='" + this.y1i_1 + "', allowSpecialFloatingPointValues=" + this.z1i_1 + ', ') + ('useAlternativeNames=' + this.a1j_1 + ', namingStrategy=' + toString_0(this.b1j_1) + ', decodeEnumsCaseInsensitive=' + this.c1j_1 + ', ') + ('allowTrailingComma=' + this.d1j_1 + ', allowComments=' + this.e1j_1 + ', classDiscriminatorMode=' + this.f1j_1.toString() + ')');
  }
}
class ClassDiscriminatorMode extends Enum {}
class JsonDecoder {}
class Companion {}
class JsonElement {}
class Companion_0 {}
class JsonArray extends JsonElement {
  constructor(content) {
    super();
    this.i1j_1 = content;
  }
  j1j(element) {
    return this.i1j_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.j1j(element instanceof JsonElement ? element : THROW_CCE());
  }
  k1j(elements) {
    return this.i1j_1.a3(elements);
  }
  a3(elements) {
    return this.k1j(elements);
  }
  h1(index) {
    return this.i1j_1.h1(index);
  }
  j1() {
    return this.i1j_1.j1();
  }
  b1() {
    return this.i1j_1.b1();
  }
  b3() {
    return this.i1j_1.b3();
  }
  k1(index) {
    return this.i1j_1.k1(index);
  }
  q1(fromIndex, toIndex) {
    return this.i1j_1.q1(fromIndex, toIndex);
  }
  g1() {
    return this.i1j_1.g1();
  }
  equals(other) {
    return equals(this.i1j_1, other);
  }
  hashCode() {
    return hashCode(this.i1j_1);
  }
  toString() {
    return joinToString(this.i1j_1, ',', '[', ']');
  }
}
class Companion_1 {}
class JsonObject extends JsonElement {
  constructor(content) {
    super();
    this.l1j_1 = content;
  }
  m1j(key) {
    return this.l1j_1.c3(key);
  }
  c3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  cj(key) {
    return this.l1j_1.e3(key);
  }
  e3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.cj((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  j1() {
    return this.l1j_1.j1();
  }
  u1() {
    return this.l1j_1.u1();
  }
  f3() {
    return this.l1j_1.f3();
  }
  g1() {
    return this.l1j_1.g1();
  }
  equals(other) {
    return equals(this.l1j_1, other);
  }
  hashCode() {
    return hashCode(this.l1j_1);
  }
  toString() {
    var tmp = this.l1j_1.u1();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  }
}
class Companion_2 {}
class JsonPrimitive extends JsonElement {
  toString() {
    return this.n1j();
  }
}
class JsonNull extends JsonPrimitive {
  constructor() {
    JsonNull_instance = null;
    super();
    JsonNull_instance = this;
    this.o1j_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p1j_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  n1j() {
    return this.o1j_1;
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class JsonLiteral extends JsonPrimitive {
  constructor(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    super();
    this.r1j_1 = isString;
    this.s1j_1 = coerceToInlineType;
    this.t1j_1 = toString(body);
    if (!(this.s1j_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.s1j_1.hx()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException.l(toString(message));
      }
    }
  }
  n1j() {
    return this.t1j_1;
  }
  toString() {
    var tmp;
    if (this.r1j_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.t1j_1);
      tmp = this_0.toString();
    } else {
      tmp = this.t1j_1;
    }
    return tmp;
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.r1j_1 === other.r1j_1))
      return false;
    if (!(this.t1j_1 === other.t1j_1))
      return false;
    return true;
  }
  hashCode() {
    var result = getBooleanHashCode(this.r1j_1);
    result = imul(31, result) + getStringHashCode(this.t1j_1) | 0;
    return result;
  }
}
class JsonElementSerializer {
  constructor() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.a1k_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  yu() {
    return this.a1k_1;
  }
  b1k(encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.q10(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.q10(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.q10(JsonArraySerializer_getInstance(), value);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  zu(encoder, value) {
    return this.b1k(encoder, value instanceof JsonElement ? value : THROW_CCE());
  }
  av(decoder) {
    var input = asJsonDecoder(decoder);
    return input.h1j();
  }
}
class JsonArrayDescriptor {
  constructor() {
    JsonArrayDescriptor_instance = this;
    this.c1k_1 = ListSerializer(JsonElementSerializer_getInstance()).yu();
    this.d1k_1 = 'kotlinx.serialization.json.JsonArray';
  }
  bx(index) {
    return this.c1k_1.bx(index);
  }
  cx(name) {
    return this.c1k_1.cx(name);
  }
  dx(index) {
    return this.c1k_1.dx(index);
  }
  ex(index) {
    return this.c1k_1.ex(index);
  }
  fx(index) {
    return this.c1k_1.fx(index);
  }
  gx() {
    return this.c1k_1.gx();
  }
  ww() {
    return this.c1k_1.ww();
  }
  hx() {
    return this.c1k_1.hx();
  }
  ix() {
    return this.c1k_1.ix();
  }
  jx() {
    return this.c1k_1.jx();
  }
  ax() {
    return this.d1k_1;
  }
}
class JsonArraySerializer {
  constructor() {
    JsonArraySerializer_instance = this;
    this.z1j_1 = JsonArrayDescriptor_getInstance();
  }
  yu() {
    return this.z1j_1;
  }
  e1k(encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).zu(encoder, value);
  }
  zu(encoder, value) {
    return this.e1k(encoder, value instanceof JsonArray ? value : THROW_CCE());
  }
  av(decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).av(decoder));
  }
}
class JsonObjectDescriptor {
  constructor() {
    JsonObjectDescriptor_instance = this;
    this.f1k_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).yu();
    this.g1k_1 = 'kotlinx.serialization.json.JsonObject';
  }
  bx(index) {
    return this.f1k_1.bx(index);
  }
  cx(name) {
    return this.f1k_1.cx(name);
  }
  dx(index) {
    return this.f1k_1.dx(index);
  }
  ex(index) {
    return this.f1k_1.ex(index);
  }
  fx(index) {
    return this.f1k_1.fx(index);
  }
  gx() {
    return this.f1k_1.gx();
  }
  ww() {
    return this.f1k_1.ww();
  }
  hx() {
    return this.f1k_1.hx();
  }
  ix() {
    return this.f1k_1.ix();
  }
  jx() {
    return this.f1k_1.jx();
  }
  ax() {
    return this.g1k_1;
  }
}
class JsonObjectSerializer {
  constructor() {
    JsonObjectSerializer_instance = this;
    this.y1j_1 = JsonObjectDescriptor_getInstance();
  }
  yu() {
    return this.y1j_1;
  }
  h1k(encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).zu(encoder, value);
  }
  zu(encoder, value) {
    return this.h1k(encoder, value instanceof JsonObject ? value : THROW_CCE());
  }
  av(decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).av(decoder));
  }
}
class JsonPrimitiveSerializer {
  constructor() {
    JsonPrimitiveSerializer_instance = this;
    this.v1j_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  yu() {
    return this.v1j_1;
  }
  i1k(encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.q10(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.q10(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  }
  zu(encoder, value) {
    return this.i1k(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  }
  av(decoder) {
    var result = asJsonDecoder(decoder).h1j();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  }
}
class JsonNullSerializer {
  constructor() {
    JsonNullSerializer_instance = this;
    this.w1j_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  yu() {
    return this.w1j_1;
  }
  j1k(encoder, value) {
    verify(encoder);
    encoder.tz();
  }
  zu(encoder, value) {
    return this.j1k(encoder, value instanceof JsonNull ? value : THROW_CCE());
  }
  av(decoder) {
    verify_0(decoder);
    if (decoder.iy()) {
      throw JsonDecodingException.q1k("Expected 'null' literal");
    }
    decoder.jy();
    return JsonNull_getInstance();
  }
}
class JsonLiteralSerializer {
  constructor() {
    JsonLiteralSerializer_instance = this;
    this.x1j_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  yu() {
    return this.x1j_1;
  }
  r1k(encoder, value) {
    verify(encoder);
    if (value.r1j_1) {
      return encoder.c10(value.t1j_1);
    }
    if (!(value.s1j_1 == null)) {
      return encoder.e10(value.s1j_1).c10(value.t1j_1);
    }
    var tmp2_safe_receiver = toLongOrNull(value.t1j_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.yz(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toULongOrNull(value.t1j_1);
    var tmp = tmp3_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp3_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).iu_1;
      var tmp_1 = encoder.e10(serializer_0(Companion_getInstance()).yu());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.yz(tmp$ret$1);
      return Unit_instance;
    }
    var tmp4_safe_receiver = toDoubleOrNull(value.t1j_1);
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.a10(tmp4_safe_receiver);
    }
    var tmp5_safe_receiver = toBooleanStrictOrNull(value.t1j_1);
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.uz(tmp5_safe_receiver);
    }
    encoder.c10(value.t1j_1);
  }
  zu(encoder, value) {
    return this.r1k(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  }
  av(decoder) {
    var result = asJsonDecoder(decoder).h1j();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  }
}
class defer$1 {
  constructor($deferred) {
    this.s1k_1 = lazy_0($deferred);
  }
  ax() {
    return _get_original__l7ku1m(this).ax();
  }
  gx() {
    return _get_original__l7ku1m(this).gx();
  }
  ix() {
    return _get_original__l7ku1m(this).ix();
  }
  bx(index) {
    return _get_original__l7ku1m(this).bx(index);
  }
  cx(name) {
    return _get_original__l7ku1m(this).cx(name);
  }
  dx(index) {
    return _get_original__l7ku1m(this).dx(index);
  }
  ex(index) {
    return _get_original__l7ku1m(this).ex(index);
  }
  fx(index) {
    return _get_original__l7ku1m(this).fx(index);
  }
}
class JsonEncoder {}
class Composer {
  constructor(writer) {
    this.t1k_1 = writer;
    this.u1k_1 = true;
  }
  v1k() {
    this.u1k_1 = true;
  }
  w1k() {
    return Unit_instance;
  }
  x1k() {
    this.u1k_1 = false;
  }
  y1k() {
    this.u1k_1 = false;
  }
  z1k() {
    return Unit_instance;
  }
  a1l(v) {
    return this.t1k_1.b1l(v);
  }
  c1l(v) {
    return this.t1k_1.d1l(v);
  }
  e1l(v) {
    return this.t1k_1.d1l(v.toString());
  }
  f1l(v) {
    return this.t1k_1.d1l(v.toString());
  }
  g1l(v) {
    return this.t1k_1.h1l(toLong(v));
  }
  i1l(v) {
    return this.t1k_1.h1l(toLong(v));
  }
  j1l(v) {
    return this.t1k_1.h1l(toLong(v));
  }
  k1l(v) {
    return this.t1k_1.h1l(v);
  }
  l1l(v) {
    return this.t1k_1.d1l(v.toString());
  }
  m1l(value) {
    return this.t1k_1.n1l(value);
  }
}
class ComposerForUnsignedNumbers extends Composer {
  constructor(writer, forceQuoting) {
    super(writer);
    this.q1l_1 = forceQuoting;
  }
  j1l(v) {
    if (this.q1l_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.m1l(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.c1l(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  }
  k1l(v) {
    if (this.q1l_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.m1l(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.c1l(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  }
  g1l(v) {
    if (this.q1l_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.m1l(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.c1l(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  }
  i1l(v) {
    if (this.q1l_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.m1l(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.c1l(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  }
}
class ComposerForUnquotedLiterals extends Composer {
  constructor(writer, forceQuoting) {
    super(writer);
    this.t1l_1 = forceQuoting;
  }
  m1l(value) {
    if (this.t1l_1) {
      super.m1l(value);
    } else {
      super.c1l(value);
    }
  }
}
class ComposerWithPrettyPrint extends Composer {
  constructor(writer, json) {
    super(writer);
    this.w1l_1 = json;
    this.x1l_1 = 0;
  }
  v1k() {
    this.u1k_1 = true;
    this.x1l_1 = this.x1l_1 + 1 | 0;
  }
  w1k() {
    this.x1l_1 = this.x1l_1 - 1 | 0;
  }
  x1k() {
    this.u1k_1 = false;
    this.c1l('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.x1l_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.c1l(this.w1l_1.c1h_1.v1i_1);
      }
       while (inductionVariable < times);
  }
  y1k() {
    if (this.u1k_1)
      this.u1k_1 = false;
    else {
      this.x1k();
    }
  }
  z1k() {
    this.a1l(_Char___init__impl__6a9atx(32));
  }
}
class JsonElementMarker {
  constructor(descriptor) {
    var tmp = this;
    tmp.y1l_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.z1l_1 = false;
  }
  a1m(index) {
    this.y1l_1.c15(index);
  }
  b1m() {
    return this.y1l_1.d15();
  }
}
class JsonException extends SerializationException {
  static h1m(message) {
    var $this = this.aw(message);
    captureStack($this, $this.g1m_1);
    return $this;
  }
}
class JsonDecodingException extends JsonException {
  static q1k(message) {
    var $this = this.h1m(message);
    captureStack($this, $this.p1k_1);
    return $this;
  }
}
class JsonEncodingException extends JsonException {
  static q1m(message) {
    var $this = this.h1m(message);
    captureStack($this, $this.p1m_1);
    return $this;
  }
}
class Tombstone {}
class JsonPath {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.v1m_1 = fillArrayVal(Array(8), null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.w1m_1 = tmp_2;
    this.x1m_1 = -1;
  }
  y1m(sd) {
    this.x1m_1 = this.x1m_1 + 1 | 0;
    var depth = this.x1m_1;
    if (depth === this.v1m_1.length) {
      resize(this);
    }
    this.v1m_1[depth] = sd;
  }
  z1m(index) {
    this.w1m_1[this.x1m_1] = index;
  }
  a1n(key) {
    var tmp;
    if (!(this.w1m_1[this.x1m_1] === -2)) {
      this.x1m_1 = this.x1m_1 + 1 | 0;
      tmp = this.x1m_1 === this.v1m_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.v1m_1[this.x1m_1] = key;
    this.w1m_1[this.x1m_1] = -2;
  }
  b1n() {
    if (this.w1m_1[this.x1m_1] === -2) {
      this.v1m_1[this.x1m_1] = Tombstone_instance;
    }
  }
  c1n() {
    var depth = this.x1m_1;
    if (this.w1m_1[depth] === -2) {
      this.w1m_1[depth] = -1;
      this.x1m_1 = this.x1m_1 - 1 | 0;
    }
    if (!(this.x1m_1 === -1)) {
      this.x1m_1 = this.x1m_1 - 1 | 0;
    }
  }
  d1n() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    this_0.gc('$');
    // Inline function 'kotlin.repeat' call
    var times = this.x1m_1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.v1m_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.gx(), LIST_getInstance())) {
            if (!(this.w1m_1[index] === -1)) {
              this_0.gc('[');
              this_0.rh(this.w1m_1[index]);
              this_0.gc(']');
            }
          } else {
            var idx = this.w1m_1[index];
            if (idx >= 0) {
              this_0.gc('.');
              this_0.gc(element.bx(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.gc('[');
            this_0.gc("'");
            this_0.fc(element);
            this_0.gc("'");
            this_0.gc(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  }
  toString() {
    return this.d1n();
  }
}
class JsonTreeReader$readDeepRecursive$slambda {
  constructor(this$0) {
    this.s1n_1 = this$0;
  }
  a1o($this$DeepRecursiveFunction, it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$DeepRecursiveFunction, it), $completion);
  }
  me(p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.a1o(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  }
}
class JsonTreeReader {
  constructor(configuration, lexer) {
    this.o1n_1 = lexer;
    this.p1n_1 = configuration.r1i_1;
    this.q1n_1 = configuration.d1j_1;
    this.r1n_1 = 0;
  }
  y1n() {
    var token = this.o1n_1.t1n();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.r1n_1 = this.r1n_1 + 1 | 0;
      if (this.r1n_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.r1n_1 = this.r1n_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.o1n_1.j1m('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  }
}
class PolymorphismValidator {
  constructor(useArrayPolymorphism, discriminator) {
    this.c1o_1 = useArrayPolymorphism;
    this.d1o_1 = discriminator;
  }
  j1g(kClass, provider) {
  }
  m1g(baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.yu();
    checkKind_0(this, descriptor, actualClass);
    if (!this.c1o_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  }
  n1g(baseClass, defaultSerializerProvider) {
  }
  o1g(baseClass, defaultDeserializerProvider) {
  }
}
class Key {}
class DescriptorSchemaCache {
  constructor() {
    this.r1m_1 = createMapForCache(16);
  }
  e1o(descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.r1m_1;
    var value_0 = this_0.e3(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.k3(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var this_1 = tmp;
    var key_0 = key instanceof Key ? key : THROW_CCE();
    var value_1 = !(value == null) ? value : THROW_CCE();
    this_1.k3(key_0, value_1);
  }
  s1m(descriptor, key, defaultValue) {
    var tmp18_safe_receiver = this.f1o(descriptor, key);
    if (tmp18_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp18_safe_receiver;
    }
    var value = defaultValue();
    this.e1o(descriptor, key, value);
    return value;
  }
  f1o(descriptor, key) {
    var tmp19_safe_receiver = this.r1m_1.e3(descriptor);
    var tmp;
    if (tmp19_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp19_safe_receiver.e3(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  }
}
class DiscriminatorHolder {
  constructor(discriminatorToSkip) {
    this.g1o_1 = discriminatorToSkip;
  }
}
class StreamingJsonDecoder extends AbstractDecoder {
  constructor(json, mode, lexer, descriptor, discriminatorHolder) {
    super();
    this.j1h_1 = json;
    this.k1h_1 = mode;
    this.l1h_1 = lexer;
    this.m1h_1 = this.j1h_1.mz();
    this.n1h_1 = -1;
    this.o1h_1 = discriminatorHolder;
    this.p1h_1 = this.j1h_1.c1h_1;
    this.q1h_1 = this.p1h_1.u1i_1 ? null : new JsonElementMarker(descriptor);
  }
  g1j() {
    return this.j1h_1;
  }
  mz() {
    return this.m1h_1;
  }
  h1j() {
    return (new JsonTreeReader(this.j1h_1.c1h_1, this.l1h_1)).y1n();
  }
  wy(deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.j1h_1.c1h_1.x1i_1;
      }
      if (tmp) {
        return deserializer.av(this);
      }
      var discriminator = classDiscriminator(deserializer.yu(), this.j1h_1);
      var tmp0_elvis_lhs = this.l1h_1.p1o(discriminator, this.p1h_1.r1i_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var deserializer_0 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
          var tmp_1;
          if (!(deserializer_0 instanceof AbstractPolymorphicSerializer)) {
            tmp_1 = true;
          } else {
            tmp_1 = this.g1j().c1h_1.x1i_1;
          }
          if (tmp_1) {
            tmp$ret$0 = deserializer_0.av(this);
            break $l$block;
          }
          var discriminator_0 = classDiscriminator(deserializer_0.yu(), this.g1j());
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.h1j();
          var serialName = deserializer_0.yu().ax();
          if (!(value instanceof JsonObject)) {
            var tmp_2 = getKClass(JsonObject).yf();
            var tmp_3 = getKClassFromExpression(value).yf();
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeSerializableValue.<anonymous>' call
            var tmp$ret$1 = this.l1h_1.s1h_1.d1n();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(value));
          }
          var jsonTree = value;
          var tmp16_safe_receiver = jsonTree.cj(discriminator_0);
          var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : get_jsonPrimitive(tmp16_safe_receiver);
          var type = tmp17_safe_receiver == null ? null : get_contentOrNull(tmp17_safe_receiver);
          var tmp_4;
          try {
            tmp_4 = findPolymorphicSerializer(deserializer_0, this, type);
          } catch ($p) {
            var tmp_5;
            if ($p instanceof SerializationException) {
              var it = $p;
              throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
            } else {
              throw $p;
            }
          }
          var tmp_6 = tmp_4;
          var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.g1j(), discriminator_0, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type_0 = tmp_0;
      var tmp_7;
      try {
        tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
      } catch ($p) {
        var tmp_8;
        if ($p instanceof SerializationException) {
          var it_0 = $p;
          var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
          this.l1h_1.j1m(message, VOID, hint);
        } else {
          throw $p;
        }
        tmp_7 = tmp_8;
      }
      var tmp_9 = tmp_7;
      var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
      this.o1h_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer_0.av(this);
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains_0(ensureNotNull(e.message), 'at path'))
          throw e;
        throw MissingFieldException.pw(e.nw_1, plus(e.message, ' at path: ') + this.l1h_1.s1h_1.d1n(), e);
      } else {
        throw $p;
      }
    }
  }
  xy(descriptor) {
    var newMode = switchMode(this.j1h_1, descriptor);
    this.l1h_1.s1h_1.y1m(descriptor);
    this.l1h_1.h1o(newMode.s1o_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.p3_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.j1h_1, newMode, this.l1h_1, descriptor, this.o1h_1);
        break;
      default:
        var tmp_0;
        if (this.k1h_1.equals(newMode) && this.j1h_1.c1h_1.u1i_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.j1h_1, newMode, this.l1h_1, descriptor, this.o1h_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  yy(descriptor) {
    if (this.j1h_1.c1h_1.q1i_1 && descriptor.ix() === 0) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.l1h_1.i1o() && !this.j1h_1.c1h_1.d1j_1) {
      invalidTrailingComma(this.l1h_1, '');
    }
    this.l1h_1.h1o(this.k1h_1.t1o_1);
    this.l1h_1.s1h_1.c1n();
  }
  iy() {
    var tmp;
    var tmp21_safe_receiver = this.q1h_1;
    var tmp0_elvis_lhs = tmp21_safe_receiver == null ? null : tmp21_safe_receiver.z1l_1;
    if (!(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs)) {
      tmp = !this.l1h_1.u1o();
    } else {
      tmp = false;
    }
    return tmp;
  }
  jy() {
    return null;
  }
  jz(descriptor, index, deserializer, previousValue) {
    var isMapKey = this.k1h_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.l1h_1.s1h_1.b1n();
    }
    var value = super.jz(descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.l1h_1.s1h_1.a1n(value);
    }
    return value;
  }
  oz(descriptor) {
    var index;
    switch (this.k1h_1.p3_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.k1h_1.equals(WriteMode_MAP_getInstance())) {
      this.l1h_1.s1h_1.z1m(index);
    }
    return index;
  }
  ky() {
    return this.l1h_1.v1o();
  }
  ly() {
    var value = this.l1h_1.u1j();
    if (!value.equals(toLong(value.k4()))) {
      this.l1h_1.j1m("Failed to parse byte for input '" + value.toString() + "'");
    }
    return value.k4();
  }
  my() {
    var value = this.l1h_1.u1j();
    if (!value.equals(toLong(value.l4()))) {
      this.l1h_1.j1m("Failed to parse short for input '" + value.toString() + "'");
    }
    return value.l4();
  }
  ny() {
    var value = this.l1h_1.u1j();
    if (!value.equals(toLong(value.l2()))) {
      this.l1h_1.j1m("Failed to parse int for input '" + value.toString() + "'");
    }
    return value.l2();
  }
  oy() {
    return this.l1h_1.u1j();
  }
  py() {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.l1h_1;
      var input = this_0.x1n();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.j1m("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.j1h_1.c1h_1.z1i_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.l1h_1, result);
  }
  qy() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.l1h_1;
      var input = this_0.x1n();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.j1m("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.j1h_1.c1h_1.z1i_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.l1h_1, result);
  }
  ry() {
    var string = this.l1h_1.x1n();
    if (!(string.length === 1)) {
      this.l1h_1.j1m("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  }
  sy() {
    var tmp;
    if (this.p1h_1.r1i_1) {
      tmp = this.l1h_1.o1o();
    } else {
      tmp = this.l1h_1.w1n();
    }
    return tmp;
  }
  uy(descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.l1h_1, this.j1h_1) : super.uy(descriptor);
  }
  ty(enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.j1h_1, this.sy(), ' at path ' + this.l1h_1.s1h_1.d1n());
  }
}
class JsonDecoderForUnsignedTypes extends AbstractDecoder {
  constructor(lexer, json) {
    super();
    this.w1o_1 = lexer;
    this.x1o_1 = json.mz();
  }
  mz() {
    return this.x1o_1;
  }
  oz(descriptor) {
    var message = 'unsupported';
    throw IllegalStateException.h5(toString(message));
  }
  ny() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.w1o_1;
      var input = this_0.x1n();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_1 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.j1m("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  oy() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.w1o_1;
      var input = this_0.x1n();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.j1m("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  ly() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.w1o_1;
      var input = this_0.x1n();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        // Inline function 'kotlin.UByte.toByte' call
        var this_1 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.j1m("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  my() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.w1o_1;
      var input = this_0.x1n();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        // Inline function 'kotlin.UShort.toShort' call
        var this_1 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.j1m("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
}
class StreamingJsonEncoder extends AbstractEncoder {
  static y1o(composer, json, mode, modeReuseCache) {
    var $this = this.qz();
    $this.e1n_1 = composer;
    $this.f1n_1 = json;
    $this.g1n_1 = mode;
    $this.h1n_1 = modeReuseCache;
    $this.i1n_1 = $this.f1n_1.mz();
    $this.j1n_1 = $this.f1n_1.c1h_1;
    $this.k1n_1 = false;
    $this.l1n_1 = null;
    $this.m1n_1 = null;
    var i = $this.g1n_1.p3_1;
    if (!($this.h1n_1 == null)) {
      if (!($this.h1n_1[i] === null) || !($this.h1n_1[i] === $this)) {
        $this.h1n_1[i] = $this;
      }
    }
    return $this;
  }
  g1j() {
    return this.f1n_1;
  }
  static n1n(output, json, mode, modeReuseCache) {
    return this.y1o(Composer_0(output, json), json, mode, modeReuseCache);
  }
  mz() {
    return this.i1n_1;
  }
  v10(descriptor, index) {
    return this.j1n_1.p1i_1;
  }
  q10(serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.g1j().c1h_1.x1i_1) {
        serializer.zu(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.g1j().c1h_1.f1j_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.g1j().c1h_1.f1j_1.p3_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call

            var it = serializer.yu().gx();
            tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.yu(), this.g1j()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          // Inline function 'kotlin.contracts.contract' call
          if (value == null) {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call
            var message = 'Value for serializer ' + toString(serializer.yu()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException.l(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          validateIfSealed$accessor$1rk9rdt(serializer, actual, baseClassDiscriminator);
        }
        checkKind(actual.yu().gx());
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
        var serialName = actualSerializer.yu().ax();
        this.l1n_1 = baseClassDiscriminator;
        this.m1n_1 = serialName;
      }
      actualSerializer.zu(this, value);
    }
  }
  xy(descriptor) {
    var newMode = switchMode(this.f1n_1, descriptor);
    if (!(newMode.s1o_1 === _Char___init__impl__6a9atx(0))) {
      this.e1n_1.a1l(newMode.s1o_1);
      this.e1n_1.v1k();
    }
    var discriminator = this.l1n_1;
    if (!(discriminator == null)) {
      var tmp0_elvis_lhs = this.m1n_1;
      encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.ax() : tmp0_elvis_lhs);
      this.l1n_1 = null;
      this.m1n_1 = null;
    }
    if (this.g1n_1.equals(newMode)) {
      return this;
    }
    var tmp25_safe_receiver = this.h1n_1;
    var tmp1_elvis_lhs = tmp25_safe_receiver == null ? null : tmp25_safe_receiver[newMode.p3_1];
    return tmp1_elvis_lhs == null ? StreamingJsonEncoder.y1o(this.e1n_1, this.f1n_1, newMode, this.h1n_1) : tmp1_elvis_lhs;
  }
  yy(descriptor) {
    if (!(this.g1n_1.t1o_1 === _Char___init__impl__6a9atx(0))) {
      this.e1n_1.w1k();
      this.e1n_1.y1k();
      this.e1n_1.a1l(this.g1n_1.t1o_1);
    }
  }
  rz(descriptor, index) {
    switch (this.g1n_1.p3_1) {
      case 1:
        if (!this.e1n_1.u1k_1) {
          this.e1n_1.a1l(_Char___init__impl__6a9atx(44));
        }

        this.e1n_1.x1k();
        break;
      case 2:
        if (!this.e1n_1.u1k_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.e1n_1.a1l(_Char___init__impl__6a9atx(44));
            this.e1n_1.x1k();
            tmp_0 = true;
          } else {
            this.e1n_1.a1l(_Char___init__impl__6a9atx(58));
            this.e1n_1.z1k();
            tmp_0 = false;
          }
          tmp.k1n_1 = tmp_0;
        } else {
          this.k1n_1 = true;
          this.e1n_1.x1k();
        }

        break;
      case 3:
        if (index === 0)
          this.k1n_1 = true;
        if (index === 1) {
          this.e1n_1.a1l(_Char___init__impl__6a9atx(44));
          this.e1n_1.z1k();
          this.k1n_1 = false;
        }

        break;
      default:
        if (!this.e1n_1.u1k_1) {
          this.e1n_1.a1l(_Char___init__impl__6a9atx(44));
        }

        this.e1n_1.x1k();
        this.c10(getJsonElementName(descriptor, this.f1n_1, index));
        this.e1n_1.a1l(_Char___init__impl__6a9atx(58));
        this.e1n_1.z1k();
        break;
    }
    return true;
  }
  r10(descriptor, index, serializer, value) {
    if (!(value == null) || this.j1n_1.u1i_1) {
      super.r10(descriptor, index, serializer, value);
    }
  }
  e10(descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.e1n_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.e1n_1;
      } else {
        var p0 = this.e1n_1.t1k_1;
        var p1 = this.k1n_1;
        tmp_0 = new ComposerForUnsignedNumbers(p0, p1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = StreamingJsonEncoder.y1o(tmp$ret$1, this.f1n_1, this.g1n_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.e1n_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.e1n_1;
      } else {
        var p0_0 = this.e1n_1.t1k_1;
        var p1_0 = this.k1n_1;
        tmp_2 = new ComposerForUnquotedLiterals(p0_0, p1_0);
      }
      var tmp$ret$3 = tmp_2;
      tmp = StreamingJsonEncoder.y1o(tmp$ret$3, this.f1n_1, this.g1n_1, null);
    } else if (!(this.l1n_1 == null)) {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeInline.<anonymous>' call
      this.m1n_1 = descriptor.ax();
      tmp = this;
    } else {
      tmp = super.e10(descriptor);
    }
    return tmp;
  }
  tz() {
    this.e1n_1.c1l('null');
  }
  uz(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.l1l(value);
    }
  }
  vz(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.g1l(value);
    }
  }
  wz(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.i1l(value);
    }
  }
  xz(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.j1l(value);
    }
  }
  yz(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.k1l(value);
    }
  }
  zz(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.e1l(value);
    }
    if (!this.j1n_1.z1i_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.e1n_1.t1k_1));
    }
  }
  a10(value) {
    if (this.k1n_1) {
      this.c10(value.toString());
    } else {
      this.e1n_1.f1l(value);
    }
    if (!this.j1n_1.z1i_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.e1n_1.t1k_1));
    }
  }
  b10(value) {
    this.c10(toString_1(value));
  }
  c10(value) {
    return this.e1n_1.m1l(value);
  }
  d10(enumDescriptor, index) {
    this.c10(enumDescriptor.bx(index));
  }
}
class AbstractJsonTreeDecoder extends NamedValueDecoder {
  constructor(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    super();
    this.b1p_1 = json;
    this.c1p_1 = value;
    this.d1p_1 = polymorphicDiscriminator;
    this.e1p_1 = this.g1j().c1h_1;
  }
  g1j() {
    return this.b1p_1;
  }
  w1() {
    return this.c1p_1;
  }
  mz() {
    return this.g1j().mz();
  }
  g1p() {
    var tmp28_safe_receiver = this.j1d();
    var tmp;
    if (tmp28_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp = this.h1p(tmp28_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? this.w1() : tmp0_elvis_lhs;
  }
  f1p(currentTag) {
    return this.l1d() + ('.' + currentTag);
  }
  h1j() {
    return this.g1p();
  }
  wy(deserializer) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.g1j().c1h_1.x1i_1;
      }
      if (tmp) {
        tmp$ret$0 = deserializer.av(this);
        break $l$block;
      }
      var discriminator = classDiscriminator(deserializer.yu(), this.g1j());
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1j();
      var serialName = deserializer.yu().ax();
      if (!(value instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).yf();
        var tmp_1 = getKClassFromExpression(value).yf();
        var tmp$ret$1 = this.l1d();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(value));
      }
      var jsonTree = value;
      var tmp16_safe_receiver = jsonTree.cj(discriminator);
      var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : get_jsonPrimitive(tmp16_safe_receiver);
      var type = tmp17_safe_receiver == null ? null : get_contentOrNull(tmp17_safe_receiver);
      var tmp_2;
      try {
        tmp_2 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_3;
        if ($p instanceof SerializationException) {
          var it = $p;
          throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
        } else {
          throw $p;
        }
      }
      var tmp_4 = tmp_2;
      var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
      tmp$ret$0 = readPolymorphicJson(this.g1j(), discriminator, jsonTree, actualSerializer);
    }
    return tmp$ret$0;
  }
  k1d(parentName, childName) {
    return childName;
  }
  xy(descriptor) {
    var currentObject = this.g1p();
    var tmp29_subject = descriptor.gx();
    var tmp;
    var tmp_0;
    if (equals(tmp29_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp29_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.g1j();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = descriptor.ax();
      if (!(currentObject instanceof JsonArray)) {
        var tmp_2 = getKClass(JsonArray).yf();
        var tmp_3 = getKClassFromExpression(currentObject).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.l1d();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(currentObject));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp29_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.g1j();
        var keyDescriptor = carrierDescriptor(descriptor.ex(0), this_0.mz());
        var keyKind = keyDescriptor.gx();
        var tmp_4;
        var tmp_5;
        if (keyKind instanceof PrimitiveKind) {
          tmp_5 = true;
        } else {
          tmp_5 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_5) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_6 = this.g1j();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_0 = descriptor.ax();
          if (!(currentObject instanceof JsonObject)) {
            var tmp_7 = getKClass(JsonObject).yf();
            var tmp_8 = getKClassFromExpression(currentObject).yf();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
            var tmp$ret$3 = this.l1d();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString(currentObject));
          }
          tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
        } else {
          if (this_0.c1h_1.s1i_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_9 = this.g1j();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_1 = descriptor.ax();
            if (!(currentObject instanceof JsonArray)) {
              var tmp_10 = getKClass(JsonArray).yf();
              var tmp_11 = getKClassFromExpression(currentObject).yf();
              // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
              var tmp$ret$7 = this.l1d();
              throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString(currentObject));
            }
            tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_4;
      } else {
        var tmp_12 = this.g1j();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_2 = descriptor.ax();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_13 = getKClass(JsonObject).yf();
          var tmp_14 = getKClassFromExpression(currentObject).yf();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
          var tmp$ret$12 = this.l1d();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString(currentObject));
        }
        tmp = new JsonTreeDecoder(tmp_12, currentObject, this.d1p_1);
      }
    }
    return tmp;
  }
  yy(descriptor) {
  }
  iy() {
    var tmp = this.g1p();
    return !(tmp instanceof JsonNull);
  }
  i1p(tag, enumDescriptor) {
    var tmp = this.g1j();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    var value = this.h1p(tag);
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = enumDescriptor.ax();
    if (!(value instanceof JsonPrimitive)) {
      var tmp_0 = getKClass(JsonPrimitive).yf();
      var tmp_1 = getKClassFromExpression(value).yf();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
      var tmp$ret$0 = this.f1p(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
    }
    return getJsonNameIndexOrThrow(enumDescriptor, tmp, value.n1j());
  }
  x1d(tag, enumDescriptor) {
    return this.i1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  }
  j1p(tag) {
    return !(this.h1p(tag) === JsonNull_getInstance());
  }
  n1d(tag) {
    return this.j1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  k1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  o1d(tag) {
    return this.k1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  l1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(literal);
        var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  p1d(tag) {
    return this.l1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  m1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(literal);
        var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  q1d(tag) {
    return this.m1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  n1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        var tmp0_elvis_lhs = get_int(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  r1d(tag) {
    return this.n1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  o1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        var tmp0_elvis_lhs = get_long(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  s1d(tag) {
    return this.o1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  p1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        var tmp0_elvis_lhs = get_float(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.g1j().c1h_1.z1i_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.g1p()));
  }
  t1d(tag) {
    return this.p1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  q1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        var tmp0_elvis_lhs = get_double(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.g1j().c1h_1.z1i_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.g1p()));
  }
  u1d(tag) {
    return this.q1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  r1p(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.h1p(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).yf();
        var tmp_0 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        var tmp0_elvis_lhs = new Char(single(literal.n1j()));
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1.n2_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  v1d(tag) {
    return this.r1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  s1p(tag) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.h1p(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).yf();
      var tmp_0 = getKClassFromExpression(value).yf();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
      var tmp$ret$0 = this.f1p(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var value_0 = value;
    if (!(value_0 instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.f1p(tag), toString(this.g1p()));
    if (!value_0.r1j_1 && !this.g1j().c1h_1.r1i_1) {
      throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.f1p(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.g1p()));
    }
    return value_0.t1j_1;
  }
  w1d(tag) {
    return this.s1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  t1p(tag, inlineDescriptor) {
    var tmp;
    if (get_isUnsignedNumber(inlineDescriptor)) {
      var tmp_0 = this.g1j();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      var value = this.h1p(tag);
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = inlineDescriptor.ax();
      if (!(value instanceof JsonPrimitive)) {
        var tmp_1 = getKClass(JsonPrimitive).yf();
        var tmp_2 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.f1p(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
      }
      var lexer = StringJsonLexer_0(tmp_0, value.n1j());
      tmp = new JsonDecoderForUnsignedTypes(lexer, this.g1j());
    } else {
      tmp = super.y1d(tag, inlineDescriptor);
    }
    return tmp;
  }
  y1d(tag, inlineDescriptor) {
    return this.t1p((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  }
  uy(descriptor) {
    return !(this.j1d() == null) ? super.uy(descriptor) : (new JsonPrimitiveDecoder(this.g1j(), this.w1(), this.d1p_1)).uy(descriptor);
  }
}
class JsonTreeDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value, polymorphicDiscriminator, polyDescriptor) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    super(json, value, polymorphicDiscriminator);
    this.a1q_1 = value;
    this.b1q_1 = polyDescriptor;
    this.c1q_1 = 0;
    this.d1q_1 = false;
  }
  w1() {
    return this.a1q_1;
  }
  oz(descriptor) {
    while (this.c1q_1 < descriptor.ix()) {
      var _unary__edvuaz = this.c1q_1;
      this.c1q_1 = _unary__edvuaz + 1 | 0;
      var name = this.e1d(descriptor, _unary__edvuaz);
      var index = this.c1q_1 - 1 | 0;
      this.d1q_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.w1();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.e1p_1.w1i_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  }
  iy() {
    return !this.d1q_1 && super.iy();
  }
  f1d(descriptor, index) {
    var strategy = namingStrategy(descriptor, this.g1j());
    var baseName = descriptor.bx(index);
    if (strategy == null) {
      if (!this.e1p_1.a1j_1)
        return baseName;
      if (this.w1().f3().z2(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.g1j(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.w1().f3();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        if (deserializationNamesMap_0.e3(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp31_safe_receiver = tmp$ret$1;
    if (tmp31_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp31_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.u1m(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  }
  h1p(tag) {
    return getValue(this.w1(), tag);
  }
  xy(descriptor) {
    if (descriptor === this.b1q_1) {
      var tmp = this.g1j();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      var value = this.g1p();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = this.b1q_1.ax();
      if (!(value instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).yf();
        var tmp_1 = getKClassFromExpression(value).yf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.l1d();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
      }
      return new JsonTreeDecoder(tmp, value, this.d1p_1, this.b1q_1);
    }
    return super.xy(descriptor);
  }
  yy(descriptor) {
    var tmp;
    if (this.e1p_1.q1i_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.gx();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.g1j());
    var tmp_1;
    if (strategy == null && !this.e1p_1.a1j_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.g1j(), descriptor).f3();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp33_safe_receiver = get_schemaCache(this.g1j()).f1o(descriptor, get_JsonDeserializationNamesKey());
      var tmp0_elvis_lhs = tmp33_safe_receiver == null ? null : tmp33_safe_receiver.f3();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var _iterator__ex2g4s = this.w1().f3().b1();
    while (_iterator__ex2g4s.c1()) {
      var key = _iterator__ex2g4s.d1();
      if (!names.z2(key) && !(key === this.d1p_1)) {
        throw UnknownKeyException(key, this.w1().toString());
      }
    }
  }
}
class JsonTreeListDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value) {
    super(json, value);
    this.k1q_1 = value;
    this.l1q_1 = this.k1q_1.g1();
    this.m1q_1 = -1;
  }
  w1() {
    return this.k1q_1;
  }
  f1d(descriptor, index) {
    return index.toString();
  }
  h1p(tag) {
    return this.k1q_1.h1(toInt(tag));
  }
  oz(descriptor) {
    while (this.m1q_1 < (this.l1q_1 - 1 | 0)) {
      this.m1q_1 = this.m1q_1 + 1 | 0;
      return this.m1q_1;
    }
    return -1;
  }
}
class JsonPrimitiveDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    super(json, value, polymorphicDiscriminator);
    this.t1q_1 = value;
    this.z1d('primitive');
  }
  w1() {
    return this.t1q_1;
  }
  oz(descriptor) {
    return 0;
  }
  h1p(tag) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(tag === 'primitive')) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException.l(toString(message));
    }
    return this.t1q_1;
  }
}
class JsonTreeMapDecoder extends JsonTreeDecoder {
  constructor(json, value) {
    super(json, value);
    this.e1r_1 = value;
    this.f1r_1 = toList(this.e1r_1.f3());
    this.g1r_1 = imul(this.f1r_1.g1(), 2);
    this.h1r_1 = -1;
  }
  w1() {
    return this.e1r_1;
  }
  f1d(descriptor, index) {
    var i = index / 2 | 0;
    return this.f1r_1.h1(i);
  }
  oz(descriptor) {
    while (this.h1r_1 < (this.g1r_1 - 1 | 0)) {
      this.h1r_1 = this.h1r_1 + 1 | 0;
      return this.h1r_1;
    }
    return -1;
  }
  h1p(tag) {
    return (this.h1r_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.e1r_1, tag);
  }
  yy(descriptor) {
  }
}
class WriteMode extends Enum {
  constructor(name, ordinal, begin, end) {
    super(name, ordinal);
    this.s1o_1 = begin;
    this.t1o_1 = end;
  }
}
class AbstractJsonLexer {
  constructor() {
    this.r1h_1 = 0;
    this.s1h_1 = new JsonPath();
    this.t1h_1 = null;
    this.u1h_1 = StringBuilder.f();
  }
  l1r() {
  }
  i1o() {
    var current = this.m1r();
    var source = this.j1r();
    if (current >= charSequenceLength(source) || current === -1)
      return false;
    if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
      this.r1h_1 = this.r1h_1 + 1 | 0;
      return true;
    }
    return false;
  }
  n1r(c) {
    return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
  }
  v1h() {
    var nextToken = this.z1n();
    if (!(nextToken === 10)) {
      this.j1m('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.j1r(), this.r1h_1 - 1 | 0)) + ' instead');
    }
  }
  u1n(expected) {
    var token = this.z1n();
    if (!(token === expected)) {
      this.o1r(expected);
    }
    return token;
  }
  p1r(expected) {
    if (this.r1h_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.r1h_1;
        try {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.unexpectedToken.<anonymous>' call
          this.r1h_1 = this.r1h_1 - 1 | 0;
          tmp$ret$1 = this.x1n();
          break $l$block;
        }finally {
          this.r1h_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$1;
      if (inputLiteral === 'null') {
        this.i1m("Expected string literal but 'null' literal was found", this.r1h_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    this.o1r(charToTokenClass(expected));
  }
  q1r(expectedToken, wasConsumed) {
    var expected = tokenDescription(expectedToken);
    var position = wasConsumed ? this.r1h_1 - 1 | 0 : this.r1h_1;
    var s = this.r1h_1 === charSequenceLength(this.j1r()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.j1r(), position));
    this.j1m('Expected ' + expected + ", but had '" + s + "' instead", position);
  }
  o1r(expectedToken, wasConsumed, $super) {
    wasConsumed = wasConsumed === VOID ? true : wasConsumed;
    return $super === VOID ? this.q1r(expectedToken, wasConsumed) : $super.q1r.call(this, expectedToken, wasConsumed);
  }
  t1n() {
    var source = this.j1r();
    var cpos = this.r1h_1;
    $l$loop_0: while (true) {
      cpos = this.k1r(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.r1h_1 = cpos;
      return charToTokenClass(ch);
    }
    this.r1h_1 = cpos;
    return 10;
  }
  j1o(doConsume) {
    var current = this.m1r();
    current = this.k1r(current);
    var len = charSequenceLength(this.j1r()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet('null', i) === charSequenceGet(this.j1r(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.j1r(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.r1h_1 = current + 4 | 0;
    }
    return true;
  }
  u1o(doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.j1o(doConsume) : $super.j1o.call(this, doConsume);
  }
  k1o(isLenient) {
    var token = this.t1n();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.x1n();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.w1n();
    }
    var string = tmp;
    this.t1h_1 = string;
    return string;
  }
  r1r() {
    this.t1h_1 = null;
  }
  yh(startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.j1r();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  }
  w1n() {
    if (!(this.t1h_1 == null)) {
      return takePeeked(this);
    }
    return this.n1o();
  }
  consumeString2(source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.k1r(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.j1m('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.i1r(lastPosition, currentPosition);
          currentPosition = this.k1r(currentPosition);
          if (currentPosition === -1) {
            this.j1m('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.yh(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.r1h_1 = currentPosition + 1 | 0;
    return string;
  }
  o1o() {
    var result = this.x1n();
    if (result === 'null' && wasUnquotedString(this)) {
      this.j1m("Unexpected 'null' value instead of string literal");
    }
    return result;
  }
  x1n() {
    if (!(this.t1h_1 == null)) {
      return takePeeked(this);
    }
    var current = this.m1r();
    if (current >= charSequenceLength(this.j1r()) || current === -1) {
      this.j1m('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.j1r(), current));
    if (token === 1) {
      return this.w1n();
    }
    if (!(token === 0)) {
      this.j1m('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.j1r(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.j1r(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.j1r())) {
        usedAppend = true;
        this.i1r(this.r1h_1, current);
        var eof = this.k1r(current);
        if (eof === -1) {
          this.r1h_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.yh(this.r1h_1, current);
    } else {
      tmp = decodedString(this, this.r1h_1, current);
    }
    var result = tmp;
    this.r1h_1 = current;
    return result;
  }
  i1r(fromIndex, toIndex) {
    this.u1h_1.oh(this.j1r(), fromIndex, toIndex);
  }
  m1o(allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList.z();
    var lastToken = this.t1n();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.x1n();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.t1n();
      if (lastToken === 1) {
        if (allowLenientStrings)
          this.x1n();
        else
          this.n1o();
        continue $l$loop;
      }
      var tmp40_subject = lastToken;
      if (tmp40_subject === 8 || tmp40_subject === 6) {
        tokenStack.h(lastToken);
      } else if (tmp40_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.r1h_1, 'found ] instead of } at path: ' + this.s1h_1.toString(), this.j1r());
        removeLast(tokenStack);
      } else if (tmp40_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.r1h_1, 'found } instead of ] at path: ' + this.s1h_1.toString(), this.j1r());
        removeLast(tokenStack);
      } else if (tmp40_subject === 10) {
        this.j1m('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.z1n();
      if (tokenStack.g1() === 0)
        return Unit_instance;
    }
  }
  toString() {
    return "JsonReader(source='" + toString(this.j1r()) + "', currentPosition=" + this.r1h_1 + ')';
  }
  l1o(key) {
    var processed = this.yh(0, this.r1h_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.i1m("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  }
  i1m(message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.s1h_1.d1n() + hintMessage, this.j1r());
  }
  j1m(message, position, hint, $super) {
    position = position === VOID ? this.r1h_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.i1m(message, position, hint) : $super.i1m.call(this, message, position, hint);
  }
  u1j() {
    var current = this.m1r();
    current = this.k1r(current);
    if (current >= charSequenceLength(this.j1r()) || current === -1) {
      this.j1m('EOF');
    }
    var tmp;
    if (charSequenceGet(this.j1r(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.j1r())) {
        this.j1m('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.j1r()))) {
      var ch = charSequenceGet(this.j1r(), current);
      if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
        if (current === start) {
          this.j1m('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
        if (current === start) {
          this.j1m("Unexpected symbol '-' in numeric literal");
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
        if (current === start) {
          this.j1m("Unexpected symbol '+' in numeric literal");
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.j1m("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.j1m("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        exponentAccumulator = exponentAccumulator.x3(toLong(10)).w3(toLong(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.times' call
      accumulator = accumulator.x3(toLong(10)).c2(toLong(digit));
      if (accumulator.b2(new Long(0, 0)) > 0) {
        this.j1m('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.j1m('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.j1m('EOF');
      }
      if (!(charSequenceGet(this.j1r(), current) === _Char___init__impl__6a9atx(34))) {
        this.j1m('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.r1h_1 = current;
    if (hasExponent) {
      var doubleAccumulator = accumulator.n4() * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      if (doubleAccumulator > (new Long(-1, 2147483647)).n4() || doubleAccumulator < (new Long(0, -2147483648)).n4()) {
        this.j1m('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.j1m("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!accumulator.equals(new Long(0, -2147483648))) {
      tmp_0 = accumulator.c4();
    } else {
      this.j1m('Numeric value overflow');
    }
    return tmp_0;
  }
  v1o() {
    var current = this.m1r();
    if (current === charSequenceLength(this.j1r())) {
      this.j1m('EOF');
    }
    var tmp;
    if (charSequenceGet(this.j1r(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.r1h_1 === charSequenceLength(this.j1r())) {
        this.j1m('EOF');
      }
      if (!(charSequenceGet(this.j1r(), this.r1h_1) === _Char___init__impl__6a9atx(34))) {
        this.j1m('Expected closing quotation mark');
      }
      this.r1h_1 = this.r1h_1 + 1 | 0;
    }
    return result;
  }
}
class CharMappings {
  constructor() {
    CharMappings_instance = this;
    this.s1r_1 = charArray(117);
    this.t1r_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
}
class StringJsonLexer extends AbstractJsonLexer {
  constructor(source) {
    super();
    this.d1s_1 = source;
  }
  j1r() {
    return this.d1s_1;
  }
  k1r(position) {
    return position < this.j1r().length ? position : -1;
  }
  z1n() {
    var source = this.j1r();
    var cpos = this.r1h_1;
    $l$loop: while (!(cpos === -1) && cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charSequenceGet(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.r1h_1 = cpos;
      return charToTokenClass(c);
    }
    this.r1h_1 = source.length;
    return 10;
  }
  v1n() {
    var current = this.r1h_1;
    if (current === -1)
      return false;
    var source = this.j1r();
    $l$loop: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.r1h_1 = current;
      return this.n1r(c);
    }
    this.r1h_1 = current;
    return false;
  }
  m1r() {
    var current = this.r1h_1;
    if (current === -1)
      return current;
    var source = this.j1r();
    $l$loop: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.r1h_1 = current;
    return current;
  }
  h1o(expected) {
    if (this.r1h_1 === -1) {
      this.p1r(expected);
    }
    var source = this.j1r();
    var cpos = this.r1h_1;
    $l$loop: while (cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charSequenceGet(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.r1h_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.p1r(expected);
    }
    this.r1h_1 = -1;
    this.p1r(expected);
  }
  n1o() {
    this.h1o(_Char___init__impl__6a9atx(34));
    var current = this.r1h_1;
    var closingQuote = indexOf_0(this.j1r(), _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.x1n();
      this.q1r(1, false);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(this.j1r(), i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.j1r(), this.r1h_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.r1h_1 = closingQuote + 1 | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.j1r().substring(current, closingQuote);
  }
  p1o(keyToMatch, isLenient) {
    var positionSnapshot = this.r1h_1;
    try {
      if (!(this.z1n() === 6))
        return null;
      var firstKey = this.k1o(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.r1r();
      if (!(this.z1n() === 5))
        return null;
      return this.k1o(isLenient);
    }finally {
      this.r1h_1 = positionSnapshot;
      this.r1r();
    }
  }
}
class StringJsonLexerWithComments extends StringJsonLexer {
  z1n() {
    var source = this.j1r();
    var cpos = this.m1r();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.r1h_1 = cpos + 1 | 0;
    return charToTokenClass(charSequenceGet(source, cpos));
  }
  v1n() {
    var current = this.m1r();
    if (current >= this.j1r().length || current === -1)
      return false;
    return this.n1r(charSequenceGet(this.j1r(), current));
  }
  h1o(expected) {
    var source = this.j1r();
    var current = this.m1r();
    if (current >= source.length || current === -1) {
      this.r1h_1 = -1;
      this.p1r(expected);
    }
    var c = charSequenceGet(source, current);
    this.r1h_1 = current + 1 | 0;
    if (c === expected)
      return Unit_instance;
    else {
      this.p1r(expected);
    }
  }
  t1n() {
    var source = this.j1r();
    var cpos = this.m1r();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.r1h_1 = cpos;
    return charToTokenClass(charSequenceGet(source, cpos));
  }
  m1r() {
    var current = this.r1h_1;
    if (current === -1)
      return current;
    var source = this.j1r();
    $l$loop_1: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop_1;
      }
      if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
        var tmp43_subject = charSequenceGet(source, current + 1 | 0);
        if (tmp43_subject === _Char___init__impl__6a9atx(47)) {
          current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
          if (current === -1) {
            current = source.length;
          } else {
            current = current + 1 | 0;
          }
          continue $l$loop_1;
        } else if (tmp43_subject === _Char___init__impl__6a9atx(42)) {
          current = indexOf(source, '*/', current + 2 | 0);
          if (current === -1) {
            this.r1h_1 = source.length;
            this.j1m('Expected end of the block comment: "*/", but had EOF instead');
          } else {
            current = current + 2 | 0;
          }
          continue $l$loop_1;
        }
      }
      break $l$loop_1;
    }
    this.r1h_1 = current;
    return current;
  }
}
class JsonToStringWriter {
  constructor() {
    this.h1h_1 = StringBuilder.mc(128);
  }
  h1l(value) {
    this.h1h_1.sh(value);
  }
  b1l(char) {
    this.h1h_1.hc(char);
  }
  d1l(text) {
    this.h1h_1.gc(text);
  }
  n1l(text) {
    printQuoted(this.h1h_1, text);
  }
  i1h() {
    this.h1h_1.ai();
  }
  toString() {
    return this.h1h_1.toString();
  }
}
//endregion
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new Default();
  return Default_instance;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new JsonBuilder(from);
  builderAction(builder);
  var conf = builder.o1i();
  return new JsonImpl(conf, builder.n1i_1);
}
function validateConfiguration($this) {
  if (equals($this.mz(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new PolymorphismValidator($this.c1h_1.x1i_1, $this.c1h_1.y1i_1);
  $this.mz().a1g(collector);
}
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
var Companion_instance;
function Companion_getInstance_3() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.v1();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.w1();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
  printQuoted(this_0, k);
  this_0.hc(_Char___init__impl__6a9atx(58));
  this_0.fc(v);
  return this_0.toString();
}
var Companion_instance_2;
function Companion_getInstance_6() {
  return Companion_instance_2;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.p1j_1.w1();
}
function JsonNull$_anonymous__enib48() {
  return JsonNullSerializer_getInstance();
}
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new JsonNull();
  return JsonNull_instance;
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, true);
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull_0(_this__u8e3s4.n1j());
}
function get_int(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.mapExceptions' call
  var tmp;
  try {
    // Inline function 'kotlinx.serialization.json.<get-int>.<anonymous>' call
    tmp = (new StringJsonLexer(_this__u8e3s4.n1j())).u1j();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      throw NumberFormatException.kf(e.message);
    } else {
      throw $p;
    }
  }
  var result = tmp;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(-2147483648, 2147483647);
  if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result))
    throw NumberFormatException.kf(_this__u8e3s4.n1j() + ' is not an Int');
  return result.l2();
}
function get_long(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.mapExceptions' call
  var tmp;
  try {
    // Inline function 'kotlinx.serialization.json.<get-long>.<anonymous>' call
    tmp = (new StringJsonLexer(_this__u8e3s4.n1j())).u1j();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      throw NumberFormatException.kf(e.message);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.n1j();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.n1j());
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.n1j();
  }
  return tmp;
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException.l('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.jv('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.jv('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.jv('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.jv('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.jv('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().v1j_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().w1j_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().x1j_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().y1j_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().z1j_1;
}
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance === VOID)
    new JsonElementSerializer();
  return JsonElementSerializer_instance;
}
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance === VOID)
    new JsonArrayDescriptor();
  return JsonArrayDescriptor_instance;
}
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance === VOID)
    new JsonArraySerializer();
  return JsonArraySerializer_instance;
}
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance === VOID)
    new JsonObjectDescriptor();
  return JsonObjectDescriptor_instance;
}
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance === VOID)
    new JsonObjectSerializer();
  return JsonObjectSerializer_instance;
}
function defer(deferred) {
  return new defer$1(deferred);
}
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance === VOID)
    new JsonPrimitiveSerializer();
  return JsonPrimitiveSerializer_instance;
}
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance === VOID)
    new JsonNullSerializer();
  return JsonNullSerializer_instance;
}
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance === VOID)
    new JsonLiteralSerializer();
  return JsonLiteralSerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.h5('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.h5('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.s1k_1;
  original$factory();
  return this_0.w1();
}
function original$factory() {
  return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
    return _get_original__l7ku1m(receiver);
  }, null);
}
function Composer_0(sb, json) {
  return json.c1h_1.t1i_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
}
function readIfAbsent($this, descriptor, index) {
  $this.z1l_1 = (!descriptor.fx(index) && descriptor.ex(index).ww());
  return $this.z1l_1;
}
function JsonElementMarker$readIfAbsent$ref($boundThis) {
  var l = function (p0, p1) {
    return readIfAbsent($boundThis, p0, p1);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
}
function JsonDecodingException_1(offset, message) {
  return JsonDecodingException.q1k(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  // Inline function 'kotlin.text.substring' call
  var startIndex = coerceAtLeast(start_0, 0);
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
}
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.i1m('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.r1h_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingCommas = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.j1m('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
function InvalidKeyKindException(keyDescriptor) {
  return JsonEncodingException.q1m("Value of type '" + keyDescriptor.ax() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.gx().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function UnknownKeyException(key, input) {
  return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString(minify(input))));
}
function InvalidFloatingPointEncoded(value, output) {
  return JsonEncodingException.q1m('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
}
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.cx(name);
  if (!(index === -3))
    return index;
  if (!json.c1h_1.a1j_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
  suffix = suffix === VOID ? '' : suffix;
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var index = getJsonNameIndex(_this__u8e3s4, json, name);
  if (index === -3)
    throw SerializationException.aw(_this__u8e3s4.ax() + " does not contain element with name '" + name + "'" + suffix);
  return index;
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.bx(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.gx(), CLASS_getInstance()) ? json.c1h_1.b1j_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.s1m(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.c1h_1.c1j_1 && equals(descriptor.gx(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).e3(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.s1m(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap.wc();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.ix();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = _this__u8e3s4.dx(i);
      var destination = ArrayList.z();
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        if (element instanceof JsonNames) {
          destination.h(element);
        }
      }
      var tmp9_safe_receiver = singleOrNull(destination);
      var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.t1m_1;
      if (tmp10_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp10_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp10_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.bx(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.u1m(_this__u8e3s4, i, _this__u8e3s4.bx(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp_1;
  if (builder.j1()) {
    // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.gx(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).c3(name)) {
    throw JsonException.h1m("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.bx(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.bx(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.k3(name, index);
}
function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
  return function () {
    return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
  };
}
function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
  return function () {
    var tmp = 0;
    var tmp_0 = $this_serializationNamesIndices.ix();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = $this_serializationNamesIndices.bx(tmp_2);
      tmp_1[tmp_2] = $strategy.u1m($this_serializationNamesIndices, tmp_2, baseName);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new Key();
    JsonSerializationNamesKey = new Key();
  }
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
function resize($this) {
  var newSize = imul($this.x1m_1, 2);
  $this.v1m_1 = copyOf($this.v1m_1, newSize);
  $this.w1m_1 = copyOf_0($this.w1m_1, newSize);
}
function encodeByWriter(json, writer, serializer, value) {
  var tmp = WriteMode_OBJ_getInstance();
  // Inline function 'kotlin.arrayOfNulls' call
  var size = get_entries().g1();
  var tmp$ret$0 = fillArrayVal(Array(size), null);
  var encoder = StreamingJsonEncoder.n1n(writer, json, tmp, tmp$ret$0);
  encoder.q10(serializer, value);
}
function *_generator_invoke__zhh2q8($this, $this$DeepRecursiveFunction, it, $completion) {
  var tmp14_subject = $this.s1n_1.o1n_1.t1n();
  var tmp;
  if (tmp14_subject === 1) {
    tmp = readValue($this.s1n_1, true);
  } else if (tmp14_subject === 0) {
    tmp = readValue($this.s1n_1, false);
  } else if (tmp14_subject === 6) {
    var tmp_0 = readObject_0($this$DeepRecursiveFunction, $this.s1n_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else if (tmp14_subject === 8) {
    tmp = readArray($this.s1n_1);
  } else {
    $this.s1n_1.o1n_1.j1m("Can't begin reading element, unexpected token");
  }
  return tmp;
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.o1n_1.u1n(6);
  if ($this.o1n_1.t1n() === 4) {
    $this.o1n_1.j1m('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap.wc();
  $l$loop: while ($this.o1n_1.v1n()) {
    var key = $this.p1n_1 ? $this.o1n_1.x1n() : $this.o1n_1.w1n();
    $this.o1n_1.u1n(5);
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
    var element = $this.y1n();
    // Inline function 'kotlin.collections.set' call
    result.k3(key, element);
    lastToken = $this.o1n_1.z1n();
    var tmp13_subject = lastToken;
    if (tmp13_subject !== 4)
      if (tmp13_subject === 7)
        break $l$loop;
      else {
        $this.o1n_1.j1m('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.o1n_1.u1n(7);
  } else if (lastToken === 4) {
    if (!$this.q1n_1) {
      invalidTrailingComma($this.o1n_1);
    }
    $this.o1n_1.u1n(7);
  }
  return new JsonObject(result);
}
function *_generator_readObject__361wel(_this__u8e3s4, $this, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.o1n_1.u1n(6);
  if ($this.o1n_1.t1n() === 4) {
    $this.o1n_1.j1m('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap.wc();
  $l$loop: while ($this.o1n_1.v1n()) {
    var key = $this.p1n_1 ? $this.o1n_1.x1n() : $this.o1n_1.w1n();
    $this.o1n_1.u1n(5);
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
    var tmp = _this__u8e3s4.ts(Unit_instance, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var element = tmp;
    // Inline function 'kotlin.collections.set' call
    result.k3(key, element);
    lastToken = $this.o1n_1.z1n();
    var tmp13_subject = lastToken;
    if (tmp13_subject !== 4)
      if (tmp13_subject === 7)
        break $l$loop;
      else {
        $this.o1n_1.j1m('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.o1n_1.u1n(7);
  } else if (lastToken === 4) {
    if (!$this.q1n_1) {
      invalidTrailingComma($this.o1n_1);
    }
    $this.o1n_1.u1n(7);
  }
  return new JsonObject(result);
}
function readObject_0(_this__u8e3s4, $this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readObject__361wel.bind(VOID, _this__u8e3s4, $this), $completion);
}
function readArray($this) {
  var lastToken = $this.o1n_1.z1n();
  if ($this.o1n_1.t1n() === 4) {
    $this.o1n_1.j1m('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList.z();
  while ($this.o1n_1.v1n()) {
    var element = $this.y1n();
    result.h(element);
    lastToken = $this.o1n_1.z1n();
    if (!(lastToken === 4)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var this_0 = $this.o1n_1;
      var condition = lastToken === 9;
      var position = this_0.r1h_1;
      if (!condition) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
        var tmp$ret$1 = 'Expected end of the array or comma';
        this_0.j1m(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.o1n_1.u1n(9);
  } else if (lastToken === 4) {
    if (!$this.q1n_1) {
      invalidTrailingComma($this.o1n_1, 'array');
    }
    $this.o1n_1.u1n(9);
  }
  return new JsonArray(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.p1n_1 || !isString) {
    tmp = $this.o1n_1.x1n();
  } else {
    tmp = $this.o1n_1.w1n();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new JsonLiteral(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this$0);
  var l = function ($this$DeepRecursiveFunction, it, $completion) {
    return i.a1o($this$DeepRecursiveFunction, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.jx().b1();
  while (_iterator__ex2g4s.c1()) {
    var annotation = _iterator__ex2g4s.d1();
    if (annotation instanceof JsonClassDiscriminator)
      return annotation.b1o_1;
  }
  return json.c1h_1.y1i_1;
}
function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
  if (!(serializer instanceof SealedClassSerializer))
    return Unit_instance;
  if (jsonCachedSerialNames(actualSerializer.yu()).z2(classDiscriminator)) {
    var baseName = serializer.yu().ax();
    var actualName = actualSerializer.yu().ax();
    // Inline function 'kotlin.error' call
    var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
    throw IllegalStateException.h5(toString(message));
  }
}
function checkKind(kind) {
  if (kind instanceof ENUM) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException.h5(toString(message));
  }
  if (kind instanceof PrimitiveKind) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException.h5(toString(message_0));
  }
  if (kind instanceof PolymorphicKind) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException.h5(toString(message_1));
  }
}
function validateIfSealed$accessor$1rk9rdt(serializer, actualSerializer, classDiscriminator) {
  return validateIfSealed(serializer, actualSerializer, classDiscriminator);
}
function checkKind_0($this, descriptor, actualClass) {
  var kind = descriptor.gx();
  var tmp;
  if (kind instanceof PolymorphicKind) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException.l('Serializer for ' + actualClass.yf() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.c1o_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind;
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM;
  }
  if (tmp_0) {
    throw IllegalArgumentException.l('Serializer for ' + actualClass.yf() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
function checkDiscriminatorCollisions($this, descriptor, actualClass) {
  var inductionVariable = 0;
  var last = descriptor.ix();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var name = descriptor.bx(i);
      if (name === $this.d1o_1) {
        throw IllegalArgumentException.l('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
      }
    }
     while (inductionVariable < last);
}
function trySkip(_this__u8e3s4, $this, unknownKey) {
  if (_this__u8e3s4 == null)
    return false;
  if (_this__u8e3s4.g1o_1 === unknownKey) {
    _this__u8e3s4.g1o_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.oz(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.l1h_1.t1n() === 4) {
    $this.l1h_1.j1m('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.n1h_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.n1h_1 === -1)) {
      hasComma = $this.l1h_1.i1o();
    }
  } else {
    $this.l1h_1.h1o(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.l1h_1.v1n()) {
    if (decodingKey) {
      if ($this.n1h_1 === -1) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_0 = $this.l1h_1;
        var condition = !hasComma;
        var position = this_0.r1h_1;
        if (!condition) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
          var tmp$ret$0 = 'Unexpected leading comma';
          this_0.j1m(tmp$ret$0, position);
        }
      } else {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_1 = $this.l1h_1;
        var condition_0 = hasComma;
        var position_0 = this_1.r1h_1;
        if (!condition_0) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
          var tmp$ret$1 = 'Expected comma after the key-value pair';
          this_1.j1m(tmp$ret$1, position_0);
        }
      }
    }
    $this.n1h_1 = $this.n1h_1 + 1 | 0;
    tmp = $this.n1h_1;
  } else {
    if (hasComma && !$this.j1h_1.c1h_1.d1j_1) {
      invalidTrailingComma($this.l1h_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var this_0 = $this.j1h_1;
    var isOptional = descriptor.fx(index);
    var elementDescriptor = descriptor.ex(index);
    var tmp;
    if (isOptional && !elementDescriptor.ww()) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
      tmp = $this.l1h_1.j1o(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.gx(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.ww()) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp_0 = $this.l1h_1.j1o(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
      var tmp0_elvis_lhs = $this.l1h_1.k1o($this.p1h_1.r1i_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
      var coerceToNull = !this_0.c1h_1.u1i_1 && elementDescriptor.ww();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        $this.l1h_1.w1n();
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.l1h_1.i1o();
  while ($this.l1h_1.v1n()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.l1h_1.h1o(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.j1h_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.p1h_1.w1i_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.l1h_1.i1o();
        tmp_0 = false;
      } else {
        var tmp23_safe_receiver = $this.q1h_1;
        if (tmp23_safe_receiver == null)
          null;
        else {
          tmp23_safe_receiver.a1m(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, key);
    }
  }
  if (hasComma && !$this.j1h_1.c1h_1.d1j_1) {
    invalidTrailingComma($this.l1h_1);
  }
  var tmp24_safe_receiver = $this.q1h_1;
  var tmp0_elvis_lhs = tmp24_safe_receiver == null ? null : tmp24_safe_receiver.b1m();
  return tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
}
function handleUnknown($this, key) {
  if ($this.p1h_1.q1i_1 || trySkip($this.o1h_1, $this, key)) {
    $this.l1h_1.m1o($this.p1h_1.r1i_1);
  } else {
    $this.l1h_1.l1o(key);
  }
  return $this.l1h_1.i1o();
}
function decodeListIndex($this) {
  var hasComma = $this.l1h_1.i1o();
  var tmp;
  if ($this.l1h_1.v1n()) {
    if (!($this.n1h_1 === -1) && !hasComma) {
      $this.l1h_1.j1m('Expected end of the array or comma');
    }
    $this.n1h_1 = $this.n1h_1 + 1 | 0;
    tmp = $this.n1h_1;
  } else {
    if (hasComma && !$this.j1h_1.c1h_1.d1j_1) {
      invalidTrailingComma($this.l1h_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.p1h_1.r1i_1) {
    tmp = $this.l1h_1.o1o();
  } else {
    tmp = $this.l1h_1.n1o();
  }
  return tmp;
}
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.e1n_1.x1k();
  $this.c10(discriminator);
  $this.e1n_1.a1l(_Char___init__impl__6a9atx(58));
  $this.e1n_1.z1k();
  $this.c10(serialName);
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.hx() && get_unsignedNumberDescriptors().z2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.hx() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).yu(), serializer_0(Companion_getInstance()).yu(), serializer_2(Companion_getInstance_1()).yu(), serializer_3(Companion_getInstance_2()).yu()]);
  }
}
function get_ESCAPE_STRINGS() {
  _init_properties_StringOps_kt__fcy1db();
  return ESCAPE_STRINGS;
}
var ESCAPE_STRINGS;
var ESCAPE_MARKERS;
function toHexChar(i) {
  _init_properties_StringOps_kt__fcy1db();
  var d = i & 15;
  var tmp;
  if (d < 10) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp = numberToChar(d + tmp$ret$0 | 0);
  } else {
    var tmp_0 = d - 10 | 0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
  }
  return tmp;
}
function printQuoted(_this__u8e3s4, value) {
  _init_properties_StringOps_kt__fcy1db();
  _this__u8e3s4.hc(_Char___init__impl__6a9atx(34));
  var lastPos = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(value) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(value, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
        _this__u8e3s4.oh(value, lastPos, i);
        _this__u8e3s4.gc(get_ESCAPE_STRINGS()[c]);
        lastPos = i + 1 | 0;
      }
    }
     while (inductionVariable <= last);
  if (!(lastPos === 0))
    _this__u8e3s4.oh(value, lastPos, value.length);
  else
    _this__u8e3s4.gc(value);
  _this__u8e3s4.hc(_Char___init__impl__6a9atx(34));
}
function toBooleanStrictOrNull_0(_this__u8e3s4) {
  _init_properties_StringOps_kt__fcy1db();
  return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
}
var properties_initialized_StringOps_kt_wzaea7;
function _init_properties_StringOps_kt__fcy1db() {
  if (!properties_initialized_StringOps_kt_wzaea7) {
    properties_initialized_StringOps_kt_wzaea7 = true;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(93), null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = toHexChar(c >> 12);
        var c2 = toHexChar(c >> 8);
        var c3 = toHexChar(c >> 4);
        var c4 = toHexChar(c);
        this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
      }
       while (inductionVariable <= 31);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(34);
    this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(92);
    this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(9);
    this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(8);
    this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(13);
    this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
    this_0[12] = '\\f';
    ESCAPE_STRINGS = this_0;
    // Inline function 'kotlin.apply' call
    var this_7 = new Int8Array(93);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 <= 31)
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_7[c_0] = 1;
      }
       while (inductionVariable_0 <= 31);
    // Inline function 'kotlin.code' call
    var this_8 = _Char___init__impl__6a9atx(34);
    this_7[Char__toInt_impl_vasixd(this_8)] = 34;
    // Inline function 'kotlin.code' call
    var this_9 = _Char___init__impl__6a9atx(92);
    this_7[Char__toInt_impl_vasixd(this_9)] = 92;
    // Inline function 'kotlin.code' call
    var this_10 = _Char___init__impl__6a9atx(9);
    this_7[Char__toInt_impl_vasixd(this_10)] = 116;
    // Inline function 'kotlin.code' call
    var this_11 = _Char___init__impl__6a9atx(8);
    this_7[Char__toInt_impl_vasixd(this_11)] = 98;
    // Inline function 'kotlin.code' call
    var this_12 = _Char___init__impl__6a9atx(10);
    this_7[Char__toInt_impl_vasixd(this_12)] = 110;
    // Inline function 'kotlin.code' call
    var this_13 = _Char___init__impl__6a9atx(13);
    this_7[Char__toInt_impl_vasixd(this_13)] = 114;
    this_7[12] = 102;
    ESCAPE_MARKERS = this_7;
  }
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.f1p(tag), toString($this.g1p()));
}
function coerceInputValue_0($this, descriptor, index, tag) {
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var this_0 = $this.g1j();
    var isOptional = descriptor.fx(index);
    var elementDescriptor = descriptor.ex(index);
    var tmp;
    if (isOptional && !elementDescriptor.ww()) {
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
      var tmp_0 = $this.h1p(tag);
      tmp = tmp_0 instanceof JsonNull;
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.gx(), ENUM_getInstance())) {
      var tmp_1;
      if (elementDescriptor.ww()) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_2 = $this.h1p(tag);
        tmp_1 = tmp_2 instanceof JsonNull;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
      var tmp_3 = $this.h1p(tag);
      var tmp30_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
      var tmp0_elvis_lhs = tmp30_safe_receiver == null ? null : get_contentOrNull(tmp30_safe_receiver);
      var tmp_4;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_4 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_4;
      var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
      var coerceToNull = !this_0.c1h_1.u1i_1 && elementDescriptor.ww();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function absenceIsNull($this, descriptor, index) {
  $this.d1q_1 = (!$this.g1j().c1h_1.u1i_1 && !descriptor.fx(index) && descriptor.ex(index).ww());
  return $this.d1q_1;
}
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.yu())).wy(deserializer);
}
var WriteMode_OBJ_instance;
var WriteMode_LIST_instance;
var WriteMode_MAP_instance;
var WriteMode_POLY_OBJ_instance;
function values() {
  return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WriteMode_entriesInitialized;
function WriteMode_initEntries() {
  if (WriteMode_entriesInitialized)
    return Unit_instance;
  WriteMode_entriesInitialized = true;
  WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var $ENTRIES;
function switchMode(_this__u8e3s4, desc) {
  var tmp36_subject = desc.gx();
  var tmp;
  if (tmp36_subject instanceof PolymorphicKind) {
    tmp = WriteMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp36_subject, LIST_getInstance())) {
      tmp = WriteMode_LIST_getInstance();
    } else {
      if (equals(tmp36_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.ex(0), _this__u8e3s4.mz());
        var keyKind = keyDescriptor.gx();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
          tmp_0 = WriteMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.c1h_1.s1i_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = WriteMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.gx(), CONTEXTUAL_getInstance())) {
    var tmp37_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp0_elvis_lhs = tmp37_safe_receiver == null ? null : carrierDescriptor(tmp37_safe_receiver, module_0);
    tmp = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  } else if (_this__u8e3s4.hx()) {
    tmp = carrierDescriptor(_this__u8e3s4.ex(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function WriteMode_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_OBJ_instance;
}
function WriteMode_LIST_getInstance() {
  WriteMode_initEntries();
  return WriteMode_LIST_instance;
}
function WriteMode_MAP_getInstance() {
  WriteMode_initEntries();
  return WriteMode_MAP_instance;
}
function WriteMode_POLY_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_POLY_OBJ_instance;
}
function appendEscape($this, lastPosition, current) {
  $this.i1r(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.i1r(lastPosition, currentPosition);
  var result = $this.u1h_1.toString();
  $this.u1h_1.xh(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.t1h_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
  $this.t1h_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.j1r(), $this.r1h_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.k1r(currentPosition);
  if (currentPosition === -1) {
    $this.j1m('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.j1r();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.j1r(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.j1m("Invalid escaped char '" + toString_1(currentChar) + "'");
  }
  $this.u1h_1.hc(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.r1h_1 = startPos;
    $this.l1r();
    if (($this.r1h_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.j1m('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.r1h_1);
  }
  $this.u1h_1.hc(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.j1m("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.k1r(start);
  if (current >= charSequenceLength($this.j1r()) || current === -1) {
    $this.j1m('EOF');
  }
  // Inline function 'kotlin.code' call
  var tmp = $this.j1r();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp42_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp42_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp42_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.j1m("Expected valid boolean literal prefix, but had '" + $this.x1n() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.j1r()) - current | 0) < literalSuffix.length) {
    $this.j1m('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charSequenceGet(literalSuffix, i);
      var actual = charSequenceGet($this.j1r(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.j1m("Expected valid boolean literal prefix, but had '" + $this.x1n() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.r1h_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -exponentAccumulator.n4();
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = exponentAccumulator.n4();
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().t1r_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().s1r_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.s1r_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.t1r_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance === VOID)
    new CharMappings();
  return CharMappings_instance;
}
function StringJsonLexer_0(json, source) {
  return !json.c1h_1.e1j_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
}
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.e1h_1;
}
function createMapForCache(initialCapacity) {
  return HashMap.o9(initialCapacity);
}
//region block: post-declaration
initMetadataForClass(Json, 'Json');
initMetadataForObject(Default, 'Default');
initMetadataForClass(JsonBuilder, 'JsonBuilder');
initMetadataForClass(JsonImpl, 'JsonImpl');
initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
initMetadataForClass(JsonNames, 'JsonNames');
initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode');
initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForCompanion(Companion);
initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(JsonArray, 'JsonArray', VOID, VOID, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
initMetadataForCompanion(Companion_1);
initMetadataForClass(JsonObject, 'JsonObject', VOID, VOID, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
initMetadataForCompanion(Companion_2);
initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, VOID, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
initMetadataForObject(JsonNull, 'JsonNull', VOID, VOID, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
initMetadataForClass(JsonLiteral, 'JsonLiteral');
initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
protoOf(defer$1).ww = get_isNullable;
protoOf(defer$1).hx = get_isInline;
protoOf(defer$1).jx = get_annotations;
initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForClass(Composer, 'Composer');
initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers');
initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals');
initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint');
initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
initMetadataForClass(JsonException, 'JsonException');
initMetadataForClass(JsonDecodingException, 'JsonDecodingException');
initMetadataForClass(JsonEncodingException, 'JsonEncodingException');
initMetadataForObject(Tombstone, 'Tombstone');
initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, VOID, VOID, [2]);
initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [0]);
protoOf(PolymorphismValidator).l1g = contextual;
initMetadataForClass(PolymorphismValidator, 'PolymorphismValidator', VOID, VOID, [SerializersModuleCollector]);
initMetadataForClass(Key, 'Key', Key);
initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder, AbstractDecoder]);
initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes');
initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder, AbstractEncoder]);
initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, VOID, [NamedValueDecoder, JsonDecoder]);
initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder');
initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder');
initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder');
initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder');
initMetadataForClass(WriteMode, 'WriteMode');
initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
initMetadataForObject(CharMappings, 'CharMappings');
initMetadataForClass(StringJsonLexer, 'StringJsonLexer');
initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments');
initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Tombstone_instance = new Tombstone();
//endregion
//region block: exports
export {
  JsonArraySerializer_getInstance as JsonArraySerializer_getInstance1ej8z5oqdqinb,
  JsonElementSerializer_getInstance as JsonElementSerializer_getInstance2oljfos0dzhs0,
  JsonObjectSerializer_getInstance as JsonObjectSerializer_getInstance1mgth7qb9xrot,
  Json_0 as Jsonsmkyu9xjl7fv,
};
//endregion
